export default __webpack_public_path__ + "static/media/icon-chevron.258e2f4d.svg";